import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link2 from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ReactComponent as Logo } from "../logo_raywhite.svg";
import http from "../http";

function Copyright(props) {
	return (
		<Typography
			variant="body2"
			color="text.secondary"
			align="center"
			{...props}
		>
			{"Copyright © "}
			<Link2 color="inherit" href="https://www.raywhite.co.id/">
				Ray White Indonesia
			</Link2>{" "}
			{new Date().getFullYear()}
			{"."}
		</Typography>
	);
}

const theme = createTheme();

export default function SignIn() {
	const [message, setMessage] = useState("");

	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		http
			.post("/signin", {
				email: data.get("email"),
				password: data.get("password"),
				RequestToken: true,
			})
			.then(function (response) {
				localStorage.setItem("webuser", JSON.stringify(response.data));
				window.location.reload();
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
			});
	};

	useEffect(() => {
		document.title = "Ray White Indonesia";
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					{message && (
						<Alert severity="error">
							<AlertTitle>Error</AlertTitle>
							{message}
						</Alert>
					)}

					<Avatar sx={{ m: 1 }} variant="square">
						<Logo />
					</Avatar>
					<Typography component="h1" variant="h5">
						Website
					</Typography>
					<Box
						component="form"
						onSubmit={handleSubmit}
						noValidate
						sx={{ mt: 1 }}
					>
						<TextField
							margin="normal"
							required
							fullWidth
							id="email"
							label="Email Address"
							name="email"
							autoComplete="email"
							autoFocus
						/>
						<TextField
							margin="normal"
							required
							fullWidth
							name="password"
							label="Password"
							type="password"
							id="password"
							autoComplete="current-password"
						/>

						<Button
							type="submit"
							fullWidth
							variant="contained"
							sx={{ mt: 3, mb: 2 }}
						>
							Sign In
						</Button>
						<Grid container>
							<Grid item xs>
								<Link2
									href="https://my.raywhite.co.id/login/forgot"
									variant="body2"
								>
									Forgot password?
								</Link2>
							</Grid>
						</Grid>
					</Box>
				</Box>
				<Copyright sx={{ mt: 8, mb: 4 }} />
			</Container>
		</ThemeProvider>
	);
}
